<template>
  <div>
    <WebHeaderView :title="$route.query.gamename" />
    <div class="page-content">
      <div v-if="!url && false">
        <div class="loading-box">
          <van-loading type="spinner" vertical />
          <span style="color: #fff">加载中...</span>
        </div>
      </div>
      <div
        v-else
        style="
          height: calc(100vh - 50px);
          overflow-y: scroll;
          -webkit-overflow-scrolling: touch;
        "
      >
        <iframe
          style="height: 100%; width: 100%"
          ref="iframe"
          scrolling="auto"
          frameborder="0"
          id="iframe"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
export default {
  name: 'GameView',
  components: { WebHeaderView },
  data () {
    return {
      url: null
    }
  },
  mounted () {
    const query = this.$route.query
    if (query.name && query.name.length > 0) {
      this.goGamePage(query.name, query.type, query.code,query.supplier);
    }
  },
  updated () {
    this.$refs.iframe.contentWindow.location.replace(this.url)
  },
  methods: {
    async goGamePage (name, type, code, supplier) {
      await this.$http({
        method: 'post',
        url: 'getGame',
        data: {
          plat_name: name,
          game_type: type || 0,
          game_code: code,
          is_mobile_url: 1,
          supplier: supplier
        }
      }).then(data => {
        this.url = data.data.url
      })
    }
  }
}
</script>
<style scoped>
.loading-box{
  margin-top: calc((100vh - 100px) / 2);
}
</style>
